import { createContext, useContext, useState, useCallback } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

const AlertDialogContext = createContext(null)

export function AlertDialogProvider({ children }) {
  const [state, setState] = useState({ open: false })

  const showAlert = useCallback(({ title, content, okText = "OK", onOk, width }) => {
    setState({ open: true, title, content, okText, onOk, width })
  }, [])

  const handleClose = () => {
    if (state.onOk) state.onOk()
    setState({ open: false })
  }

  return (
    <AlertDialogContext.Provider value={showAlert}>
      {children}
      <Dialog open={state.open} onOpenChange={(open) => !open && handleClose()}>
        <DialogContent className={state.width ? `max-w-[${state.width}px]` : ""}>
          <DialogHeader>
            <DialogTitle>{state.title}</DialogTitle>
            {state.content && (
              typeof state.content === "string"
                ? <DialogDescription>{state.content}</DialogDescription>
                : <div className="text-sm text-neutral-500 mt-2">{state.content}</div>
            )}
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={handleClose}>{state.okText}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </AlertDialogContext.Provider>
  )
}

export function useAlertDialog() {
  const ctx = useContext(AlertDialogContext)
  if (!ctx) throw new Error("useAlertDialog must be used inside AlertDialogProvider")
  return ctx
}
